<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                    </div>
                    <div class="top_search">
                        <van-search
                            v-model="searchForm.keyword"
                            placeholder="请输入查询内容"
                            @search="onSearch"
                            @clear="onSearch"
                        >
                        </van-search>
                    </div>
                    <div class="all_menu_list">
                        <ul>
                            <li
                                v-for="item in tabList"
                                :key="item.name"
                                :class="{ active: tabActiveName == item.name }"
                                @click="handleClickTab(item)"
                            >
                                <span>{{ item.label }}</span>
                            </li>
                        </ul>
                        <div class="all_menu_filter_icon" @click="handleClickCategoryPickerShow">
                            <img
                                src="https://download.hecoos.com/enlightv/2024-51/4c642c0c14402f868ad37bc896bb25fb.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="mobile_container">
                        <div class="finance_filter">
                            <div class="finance_filter_right" @click="timeRadioPicker = true">
                                <span v-text="timeTypeList.find((item) => item.value === filterTimeType).name"></span>
                                <i class="el-icon-caret-bottom"></i>
                            </div>
                        </div>
                        <ul class="static_num_top">
                            <template v-if="tabActiveName == 'receivableSummary'">
                                <li>
                                    <p>应收待确认汇总金额</p>
                                    <p>
                                        {{
                                            Number(
                                                summaryData.summary_data &&
                                                    summaryData.summary_data.pending_confirmation_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }}
                                    </p>
                                </li>
                                <li>
                                    <p>应收已确认汇总金额</p>
                                    <p>
                                        {{
                                            Number(
                                                summaryData.summary_data &&
                                                    summaryData.summary_data.confirmed_confirmation_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }}
                                    </p>
                                </li>
                                <li>
                                    <p>应收已驳回汇总金额</p>
                                    <p
                                        v-text="
                                            Number(
                                                summaryData.summary_data &&
                                                    summaryData.summary_data.rejected_confirmation_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></p>
                                </li>
                            </template>
                            <template v-else-if="tabActiveName == 'purchase'">
                                <li>
                                    <p>采购退款待确认总金额</p>
                                    <p>
                                        {{
                                            Number(
                                                summaryData.summary_data &&
                                                    summaryData.summary_data.pending_confirmation_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }}
                                    </p>
                                </li>
                                <li>
                                    <p>采购退款已确认总金额</p>
                                    <p>
                                        {{
                                            Number(
                                                summaryData.summary_data &&
                                                    summaryData.summary_data.confirmed_confirmation_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }}
                                    </p>
                                </li>
                            </template>
                            <template v-else-if="tabActiveName == 'orderRefund'">
                                <li>
                                    <p>订单回款待确认总金额</p>
                                    <p>
                                        {{
                                            Number(
                                                summaryData.summary_data &&
                                                    summaryData.summary_data.pending_confirmation_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }}
                                    </p>
                                </li>
                                <li>
                                    <p>订单回款已确认总金额</p>
                                    <p>
                                        {{
                                            Number(
                                                summaryData.summary_data &&
                                                    summaryData.summary_data.confirmed_confirmation_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }}
                                    </p>
                                </li>
                                <li>
                                    <p>订单回款已驳回总金额</p>
                                    <p
                                        v-text="
                                            Number(
                                                summaryData.summary_data &&
                                                    summaryData.summary_data.rejected_confirmation_amount
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></p>
                                </li>
                            </template>
                            <template v-else-if="tabActiveName == 'unRefund'">
                                <li>
                                    <p>未回款总金额</p>
                                    <p
                                        v-text="
                                            Number(summaryData.total_unpaid_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></p>
                                </li>
                            </template>
                            <template v-else>
                                <li>
                                    <p>坏账总金额</p>
                                    <p
                                        v-text="
                                            Number(summaryData.total_bad_debt_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></p>
                                </li>
                            </template>
                        </ul>
                        <div class="chart_box">
                            <div class="chart_box_time_type">
                                <span
                                    v-for="item in chartDateTypeList"
                                    :key="item.type"
                                    :class="{ active: chartDateType === item.type }"
                                    @click="handleClickChartType(item.type)"
                                    >{{ item.name }}</span
                                >
                            </div>
                            <div class="echarts_container" id="container1"></div>
                        </div>
                        <ul class="list_wrap">
                            <li class="list_item" v-for="row in summaryData.list_data">
                                <p>
                                    <span v-if="tabActiveName == 'receivableSummary'">{{
                                        row.customer_name || row.supplier_name || "--"
                                    }}</span>
                                    <span v-else-if="tabActiveName == 'orderRefund'">{{
                                        row.payment_company_name || "--"
                                    }}</span>
                                    <span v-else-if="tabActiveName == 'purchase'">{{ row.supplier_name || "--" }}</span>
                                    <span
                                        class="link-label"
                                        @click="handleClickCustomerDetail(row.customer_id, row.customer_name)"
                                        v-else
                                        >{{ row.customer_name || "--" }}</span
                                    >
                                </p>
                                <div class="list_item_amount">
                                    <template v-if="tabActiveName == 'badDebt'">
                                        <div>
                                            <div class="list_item_amount_percent percent_bg3">
                                                坏账总金额：¥{{ row.total_bad_debt_amount }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="tabActiveName == 'unRefund'">
                                        <div>
                                            <div class="list_item_amount_percent percent_bg1">
                                                未回款总金额：¥{{ row.total_unpaid_amount }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <div class="list_item_amount_percent percent_bg1">
                                                待确认总金额：¥{{ row.pending_confirmation_amount }}
                                            </div>
                                        </div>
                                        <div>
                                            <div class="list_item_amount_percent percent_bg2">
                                                已确认总金额：¥{{ row.confirmed_confirmation_amount }}
                                            </div>
                                            <div
                                                class="list_item_amount_percent percent_bg4"
                                                v-if="
                                                    (tabActiveName == 'receivableSummary' && row.customer_id) ||
                                                    tabActiveName == 'orderRefund'
                                                "
                                            >
                                                已驳回总金额：¥{{ row.rejected_confirmation_amount }}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="list_item_bottom">
                                    <span @click="handleClickDetail(row)">明细<van-icon name="arrow" /></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                </div>
            </template>
        </PullContainer>
        <!-- 应收统计菜单类型选择 -->
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            class-name="custom_more_overlay"
            v-if="showTabPicker"
            :show="showTabPicker"
            @click="showTabPicker = false"
        >
            <div class="radio_option_wrap">
                <div class="radio_option_item" @click="handleClickCategoryPickerClose">
                    <span>应收统计分类</span>
                    <van-icon name="arrow-up" />
                </div>
                <ul class="radio_option_list">
                    <li
                        class="radio_option_item"
                        v-for="item in tabList"
                        :key="item.name"
                        @click="handleClickTab(item)"
                    >
                        <span>{{ item.label }}</span>
                        <van-icon name="success" v-if="tabActiveName == item.name" />
                    </li>
                </ul>
            </div>
        </van-overlay>
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            v-if="timeRadioPicker"
            :show="timeRadioPicker"
        >
            <div class="custome_radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        v-for="item in timeTypeList"
                        class="radio_option_item"
                        @click="handleClickTimeOption(item)"
                        v-text="item.name"
                    ></li>
                </ul>
                <div class="cancel_btn" @click="timeRadioPicker = false">取消</div>
            </div>
        </van-overlay>
        <van-calendar
            v-model="customDateVisible"
            :allow-same-day="true"
            :max-date="dateCalendarMax"
            :min-date="dateCalendarMin"
            title="选择时间"
            color="#1990FF"
            type="range"
            confirm-text="确认"
            @confirm="handleClickRangeCalendarConfirm"
        >
        </van-calendar>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { BadDebtSummary, UnpaidSummary, OrderRepaySummary, PurchaseRefundSummary, ReceivableSummary } from "@/api";
import { getDateRange, formatDate } from "@/utils";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
export default {
    name: "ReceivableStatistics",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
    },
    data() {
        return {
            searchForm: {
                keyword: "",
                date_range: "",
            },
            tabActiveName: "receivableSummary",
            tabList: [
                { name: "receivableSummary", label: "应收汇总统计", chartTitle: "应收待确认汇总金额统计" },
                { name: "orderRefund", label: "订单回款应收统计", chartTitle: "订单回款应收统计" },
                { name: "purchase", label: "采购退款应收统计", chartTitle: "采购退款待确认总金额统计" },
                { name: "unRefund", label: "未回款统计", chartTitle: "未回款总金额统计" },
                { name: "badDebt", label: "坏账款项统计", chartTitle: "坏账总金额统计" },
            ],
            filterTimeType: "month",
            timeTypeList: [
                { value: "month", name: "本月" },
                { value: "quarter", name: "本季度" },
                { value: "year", name: "本年" },
                { value: "custom", name: "自定义" },
            ],
            timeRadioPicker: false,
            showTabPicker: false,
            // 图表切换
            chartDateType: "day",
            chartDateTypeList: [
                { name: "日", type: "day" },
                { name: "周", type: "week" },
                { name: "月", type: "month" },
            ],
            // 自定义时间选择
            customDateVisible: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            // 统计数据
            summaryData: {
                total_unpaid_amount: "", // 未回款总金额
                total_bad_debt_amount: "", // 坏账总金额
                summary_data: {
                    pending_confirmation_amount: "",
                    confirmed_confirmation_amount: "",
                    rejected_confirmation_amount: "",
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
            },
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "FinanceManagement",
                    title: "首页",
                },
                {
                    icon: "icon-mobile-yingfu",
                    activeIcon: "icon-mobile-yingfu",
                    routerName: "PayableManage",
                    title: "应付",
                },
                {
                    icon: "icon-yingshou",
                    activeIcon: "icon-yingshouxuanzhong",
                    routerName: "ReceivableManage",
                    title: "应收",
                },
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "InvoiceManage",
                    title: "开票",
                },
            ],
            tabBarActive: 2,
        };
    },
    created() {
        const end = new Date();
        const start = new Date(end.getFullYear(), end.getMonth(), 1);
        this.searchForm.date_range = [formatDate(start, "date"), formatDate(end, "date")];
        this.onSearch();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        // 分类切换弹框
        handleClickCategoryPickerShow() {
            this.showTabPicker = true;
        },
        handleClickTab(item) {
            this.tabActiveName = item.name;
            this.$nextTick(() => {
                this.onSearch();
            });
        },
        handleClickCategoryPickerClose() {
            this.showTabPicker = false;
        },
        // 时间范围选择
        handleClickTimeOption(item) {
            if (item.value == "custom") {
                this.customDateVisible = true;
            } else {
                this.searchForm.date_range = getDateRange(item.value).split(" - ");
                this.onSearch();
            }
            this.filterTimeType = item.value;
            this.timeRadioPicker = false;
        },
        //日期区间确定事件
        handleClickRangeCalendarConfirm(range) {
            const [start, end] = range;
            let value = [formatDate(start, "date"), formatDate(end, "date")];
            this.searchForm.date_range = value;
            this.customDateVisible = false;
            this.onSearch();
        },
        // 图表日期类型切换
        handleClickChartType(type) {
            this.chartDateType = type;
            this.$nextTick(()=> {
                this.onSearch()
            })
        },
        onSearch() {
            this.summaryData.list_data = [];
            this.summaryData.trend_data = [];
            if (this.tabActiveName == "badDebt") {
                this.getBadDebtSummary();
            } else if (this.tabActiveName == "unRefund") {
                this.getUnpaidSummary();
            } else if (this.tabActiveName == "orderRefund") {
                this.getOrderRepaySummary();
            } else if (this.tabActiveName == "purchase") {
                this.getPurchaseRefundSummary();
            } else {
                this.getReceivableSummary();
            }
        },
        // 坏账统计数据
        getBadDebtSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            BadDebtSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "坏账总金额");
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
            });
        },
        // 未回款统计
        getUnpaidSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                // date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            UnpaidSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "未回款总金额");
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
            });
        },
        // 订单回款应收统计
        getOrderRepaySummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            OrderRepaySummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "订单回款待确认总金额");
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
            });
        },
        // 采购退款应收统计
        getPurchaseRefundSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            PurchaseRefundSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "采购退款待确认总金额");
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
            });
        },
        // 应收汇总
        getReceivableSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType,
            };
            ReceivableSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "应收待确认汇总金额统计");
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
            });
        },
        getBarData(data, tooltipName) {
            let xData = data.map((item) => item.operate_date);
            let sData = data.map((item) => item.total_amount);

            var charts = document.getElementById("container1");
            var myChart = echarts.getInstanceByDom(charts);
            if (myChart) {
                myChart.dispose();
            }
            this.getEchartsBar("container1", xData, sData, tooltipName);
        },
        getEchartsBar(id, xData, sData, tooltipName) {
            var dom = document.getElementById(id);
            this.myChartBar = echarts.init(dom);
            this.myChartBar.clear();
            var color = ["#1890ff", "#52C41B", "#FBAD13", "#FF4D4F", "#00BAAD"];
            var option;
            option = {
                color,
                grid: {
                    left: "10px",
                    top: "10px",
                    right: "10px",
                    bottom: "0",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    triggerOn: "mousemove", // 鼠标移动时触发 tooltip
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    position: function (point, params, dom, rect, size) {
                        return [point[0], point[1]];
                    },
                    formatter: function (params) {
                        let html = `<div class="custom_chart_tooltip"><p class="tooltip_title">${
                            params.name
                        }</p><p class="tooltip_content"><span>${tooltipName}</span><span class="count">${
                            params.data + "元"
                        }</span></p></div>`;
                        return html;
                    },
                },
                dataZoom: [
                    {
                        type: 'slider', // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                        bottom: 0,
                        height: 15,
                        handleSize: '100%', // 滑块手柄的大小
                        handleStyle: {
                            color: '#000',
                            shadowBlur: 3,
                            shadowColor: 'rgba(0, 0, 0, 0.6)',
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        }
                    },
                    {
                        type: 'inside', // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                    }
                ],
                xAxis: {
                    type: "category",
                    data: xData,
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#000000FF",
                    },
                },
                yAxis: {
                    type: "value",
                    name: "", // 设置 y 轴标题
                    min: 0, // 设置最小值
                    scale: true, // 允许动态缩放
                    axisLine: {
                        show: false,
                    },
                    splitLine: {},
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "rgba(0,0,0,.45)",
                        formatter: function (value) {
                            return value + "元";
                        },
                    },
                },
                series: [
                    {
                        data: sData,
                        type: "bar",
                    },
                ],
            };
            if (option && typeof option === "object") {
                this.myChartBar.setOption(option, true);
            }
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        handleResize() {
            if (this.resizeHandler) {
                clearTimeout(this.resizeHandler);
            }
            this.resizeHandler = setTimeout(() => {
                if (this.myChartBar) {
                    this.myChartBar.resize();
                }
            }, 100);
        },
        // 明细详情
        handleClickDetail(row) {
            this.$router.push({
                name: "ReceivableStatisticsDetails",
                query: {
                    tabActiveName: this.tabActiveName,
                    customer_id: row.customer_id,
                    payment_company_name: row.payment_company_name,
                    supplier_name: row.supplier_name,
                },
            });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
        if (this.myChartBar) {
            this.myChartBar.dispose();
        }
        if (this.myChartPie) {
            this.myChartPie.dispose();
        }
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/finance_management.scss";

.mobile_container {
    width: 100%;
    padding: 10px 16px;
    box-sizing: border-box;
    overflow-x: hidden;
}
</style>
<style lang="scss">
.custom_chart_tooltip {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 2px;
    box-shadow: 0px 2px 4px #0000003f;

    .tooltip_title {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.45);
    }

    .tooltip_content {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.65);
        display: flex;
        justify-content: space-between;
        gap: 24px;

        .count {
            font-weight: 500;
        }

        .chart_circle_item {
            display: flex;
            align-items: center;

            .chart_circle {
                display: inline-block;
                vertical-align: middle;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 9px;
            }
        }
    }
}
</style>
